import React, { Component } from 'react';
import { Typography } from "../ecosystem/";
import { formatPhoneNumber } from "../../helpers/formatting";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import Spinner from "../common/spinner";

const DATE_FORMAT = Tools.getDateFormats();

class PatientStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            showAsInvalid: false,
            validationError: "",
            newPatientStatus: false,
            exePatientStatus: false,
        };

    }

    componentDidUpdate( prevProps) {
        const { visitTypeAndLocationInfo } = this.props;
     
        const patientStatusExisting = visitTypeAndLocationInfo && visitTypeAndLocationInfo.patientStatusExisting;
        const patientStatusNew = visitTypeAndLocationInfo && visitTypeAndLocationInfo.patientStatusNew;

        if (this.props.isFromDotCOM && prevProps && prevProps.patientType !== this.props.patientType) {
            this.onChange(this.props.patientType);
        }  

        if ( prevProps.visitTypeAndLocationInfo !== visitTypeAndLocationInfo) {
            if (patientStatusExisting === false && patientStatusNew === true) {
                this.setState({ newPatientStatus: true })
            }
            else if (patientStatusExisting === true && patientStatusNew === false) {
                this.setState({ exePatientStatus: true })
            }
        }

        logUI("MBHWeb.UI.PatientStatus.ComponentDidUpdate", new Date(), Tools.getURLPath());
      
    }

    isValidate = () => {
        if (this.state.selected === null) {
            this.setState({ validationError: "Please make a selection." });
            return false;
        }
        return true;
    }

    isValid() {
        return this.isValidate();
    }

    onGoNext(success) {
        const { selected } = this.state;
        const { visit, visitTypeAndLocationInfo } = this.props;

        if (!success) {
            this.setState({ showAsInvalid: true });
        }

       visit.patientStatus = selected;
        if (selected && selected.toLowerCase() === "no, this is the first time") {
           visit.acceptType = "New";
        } else {
            visit.acceptType = "Existing";
        }
        const id = visitTypeAndLocationInfo && visitTypeAndLocationInfo.visitTypes[0] && visitTypeAndLocationInfo.visitTypes[0].iDs[0] && visitTypeAndLocationInfo.visitTypes[0].iDs[0].id ;
        const type = visitTypeAndLocationInfo.visitTypes[0] && visitTypeAndLocationInfo.visitTypes[0].iDs[0] && visitTypeAndLocationInfo.visitTypes[0].iDs[0].type;
        const visitTypeStartDate = visitTypeAndLocationInfo.visitTypes[0] && visitTypeAndLocationInfo.visitTypes[0].earliestCachedSlotDate && Tools.toJSDate(`${visitTypeAndLocationInfo.visitTypes[0].earliestCachedSlotDate} 00:00:00`, DATE_FORMAT);
        const visitTypeEndOfMonth =  visitTypeStartDate && Tools.getEndOfMonth(visitTypeStartDate.getFullYear(), visitTypeStartDate.getMonth());
        const visitTypeEndDate =  visitTypeEndOfMonth && `${visitTypeEndOfMonth.getFullYear()}-${visitTypeEndOfMonth.getMonth() + 1}-${visitTypeEndOfMonth.getDate()}`;
        if (id && type) {
            visit.visitType.id = id;
            visit.visitType.description = visitTypeAndLocationInfo.visitTypes[0] && visitTypeAndLocationInfo.visitTypes[0].displayName;
            visit.visitType.idType = type;
            visit.visitType.startDate = visitTypeAndLocationInfo.visitTypes[0] && visitTypeAndLocationInfo.visitTypes[0].earliestCachedSlotDate;
            visit.visitType.endDate = visitTypeEndDate;
        }

        // const loadScheduleDays = departments && departments.length === 1;
        // let startDate = Tools.toJSDate(`${routeDate} 00:00:00`, DATE_FORMAT);
        // let dtEnd = Tools.getEndOfMonth(startDate.getFullYear(), startDate.getMonth());
        // let endDate = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`
        // visit.date = this.props.routeDate ? this.props.routeDate : '';
        // visit.time = routeTime ? routeTime : "";
        //this.props.saveStepInfo({ visitTypeChanged: true, visit: visit, startDate: routeDate, endDate }, loadScheduleDays);
      
        logUI("MBHWeb.UI.PatientStatus.Continue.Clicked", new Date(), Tools.getURLPath(), { visit: visit });
        //this.props.loadVisitType(visit);
        this.props.saveStepInfo({  visit: visit });
    }

    onChange = (val) => {
        this.setState({ selected: val });
        this.setState({ showAsInvalid: false });
    }

    render() {
        const { visitTypeAndLocationInfo, isMobile } = this.props;
        const { exePatientStatus, newPatientStatus, selected, showAsInvalid, validationError } = this.state;
        const newPatient = "No, this is the first time";
        const existingPatient = "Yes, I am an established patient";
        const noSelected = newPatient === selected;
        const yesSelected = existingPatient === selected;
        const phoneNumber = visitTypeAndLocationInfo && visitTypeAndLocationInfo.departments[0] && visitTypeAndLocationInfo.departments[0] && visitTypeAndLocationInfo.departments[0].phone;

        return (
            <div className="patient-status-container sm-width-step" style={this.props.style}>
                {this.props.providerData && !this.props.providerData.displayName || !phoneNumber ? <Spinner /> : null}
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="step-heading">Have you seen {this.props.providerData && this.props.providerData.displayName} before?</h1>
                    </div>
                    <div className="col-12 patient-status-card-container step-form-container">
                        <div className="patient-status-card">
                            <div className="card rounded-0">
                                <div className={`${exePatientStatus ? "patient-disabled-container" : noSelected ? "patient-card-container location-info-card-selected" : " patient-card-container location-info-card-unselected"}`}>
                                    <div className="card-body">
                                        <label className="patient-status-radio-btn-container">
                                            <input type="radio" disabled={exePatientStatus} value={newPatient} checked={newPatient === selected} onChange={(e) => this.onChange(newPatient)} />
                                            <span className="patient-status-radio-btn" />
                                            <div className="location-radio-label">
                                                <div className="patient-status-radio-btn-label">
                                                    <Typography type="body-02" color={exePatientStatus ? "$color-secondary-a3" : noSelected ? "$color-primary-a2" : "$color-secondary-a2"}>{newPatient}</Typography>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="patient-status-card">
                            <div className="card rounded-0">
                                <div className={`${newPatientStatus ? "patient-disabled-container" : yesSelected ? "patient-card-container location-info-card-selected" : "patient-card-container location-info-card-unselected"}`}>
                                    <div className="card-body">
                                        <label className="patient-status-radio-btn-container">
                                            <input type="radio" disabled={newPatientStatus} value={existingPatient} checked={existingPatient === selected} onChange={(e) => this.onChange(existingPatient)} />
                                            <span className="patient-status-radio-btn" />
                                            <div className="location-radio-label">
                                                <div className="patient-status-radio-btn-label">
                                                    <Typography type="body-02" color={newPatientStatus ? "$color-secondary-a3" : yesSelected ? "$color-primary-a2" : "$color-secondary-a2"}>{existingPatient}</Typography>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {(exePatientStatus || newPatientStatus) && <div className="bottom-txt">
                            <Typography type="body-02" textAlign="justify">
                                {exePatientStatus ? "This provider only accepts online appointments for established patients. If you are a new patient please call" : "This provider only accepts online appointments for new patients. If you are an established patient please call"}{' '}
                                <a className="phone-link" href={"tel:" + phoneNumber}>
                                    {formatPhoneNumber(phoneNumber)}
                                </a>{' '}for further assistance
                            </Typography>
                        </div>}

                        {(showAsInvalid && validationError !== "") &&
                            <div className="text-center validation-error-container">
                                <Typography type="body-02" textAlign="center" color="$color-system-b1">{validationError}</Typography>
                            </div>
                        }

                        {/* <div className=" col-sm-12 col-md-12 col-12 status-radio-wrapper">
                                <div className="radio-btn">
                                    <div className="bsw-radio-wrapper">
                                        <label className={`radio-container ${exePatientStatus ? "unselected-container" : "selected-container"}`}>
                                            <Typography color={exePatientStatus ? "$color-secondary-a3" : "$color-primary-a2"}>{newPatient}</Typography>
                                            <input type="radio" disabled={exePatientStatus} value={newPatient} checked={newPatient === selected} onChange={(e) => this.onChange(newPatient)} />
                                            <span className="checkmark" />
                                        </label>
                                    </div>
                                    <div className="bsw-radio-wrapper">
                                        <label className={`radio-container ${newPatientStatus ? "unselected-container" : "selected-container"}`}>
                                            <Typography color={newPatientStatus ? "$color-secondary-a3" : "$color-primary-a2"}>{existingPatient}</Typography>
                                            <input type="radio" disabled={newPatientStatus} value={existingPatient} checked={existingPatient === selected} onChange={(e) => this.onChange(existingPatient)} />
                                            <span className="checkmark" />
                                        </label>
                                    </div>

                                    {/* <RadioButton disabled={patientStatus || exePatientStatus}  value={selected} handleOnclick={() => this.handleCheck(newPatient)}  
                                            label={newPatient} />
                                        <RadioButton disabled={patientStatus || newPatientStatus}  value={selected} handleOnclick={() => this.handleCheck(existingPatient)} 
                                            label={existingPatient} /> */}

                        {/* {(noSelected || yesSelected) && <div className="bottom-txt">
                                    <Typography type="body-02" textAlign="justify">
                                        {noSelected ? "This provider only accepts online appointments for established patients" : "This provider only accepts online appointments for new patients"} If you are a new patient please call{' '}
                                        <a href={"tel:" + phoneNumber}>
                                            {formatPhoneNumber(phoneNumber)}
                                        </a>{' '}for further assitance
                                    </Typography>
                                </div>}
                                {(showAsInvalid && validationError !== "") &&
                                    <div className="text-center validation-error-container">
                                        <Typography type="body-02" textAlign="center" color="$color-ui-b1">{validationError}</Typography>
                                    </div>
                                }
                            </div> */}
                    </div>
                </div>
            </div>

        )
    }
}
export default PatientStatus;